// Vendors
import { useEffect, useMemo, useState } from 'react';
// Contexts
import { useFeatureFlagsContextHook } from 'contexts/feature-flags.context';
// Event Handlers
import { FeatureFlagsHandlers } from '../handlers/feature-flags.handlers';
// Types
import type { FeatureFlagsHookType } from './types/feature-flags.hook.type';

const useFeatureFlagsHook = (): FeatureFlagsHookType => {
  const { setFeatureFlags } = useFeatureFlagsContextHook();

  const [fetching, setFetching] = useState(true);

  const { handleFetchFeatureFlagsConfiguration } = useMemo<ReturnType<typeof FeatureFlagsHandlers>>(
    () => FeatureFlagsHandlers({ setFeatureFlags, setFetching }),
    []
  );

  useEffect(() => {
    handleFetchFeatureFlagsConfiguration();
  }, []);

  return { fetching };
};

export { useFeatureFlagsHook };
